export const appointCaseManagerModalMessages = {
  title: 'Appoint case manager',
  currentCaseManager: 'Current case manager',
  youSuffix: ' (You)',
  instructionWhenSelf:
    'You are currently assigned as the case manager. You can update this by making a selection from the case managers below.',
  caseManagers: 'Case managers',
  searchPlaceholder: 'Select someone from employee directory',
  directoryTableEmpty: 'No case managers match your search.',
  assignAutomatically: 'Assign automatically',
  assignAutomaticallyDescriptionPrefix:
    'When enabled, the case is auto-routed using your routing rules. To view the rule used, open',
  routingPageLink: 'Routing page',
  assignAutomaticallyDescriptionSuffix: '.',
  cancel: 'Cancel',
  confirmSelection: 'Confirm selection',
  selectCaseManagerToast:
    'Select a case manager or turn on assign automatically.',
  accessWarningTitle: 'Report access after submission',
  accessWarningDescription:
    'You will not have access to view or edit this report after submission if you are not the case manager assigned.',
} as const;

export const caseManagerInstructionWhenOther = (name: string) =>
  `${name} is currently assigned as the case manager. You can update this by making a selection from the case managers below.`;
